// eslint-disable-next-line
import _ from 'lodash';
import {TGET_POLL_RES, TGETTING_POLL, TGOT_POLL,
  TNOT_GOT_POLL, TRESET_PDATA, TRESET_POLL_ERROR,
  TEDIT_POLL, TGET_POLLS_CREATED, TGET_POLLS_TAKEN,
  TGETTING_RAND_POLL, TGOT_RAND_POLL, TNOT_GOT_RAND_POLL,
  TSEARCHING_POLLS, TSEARCHED_POLLS, TNOT_SEARCHED_POLLS,
  TGETTING_RESULTS, TGOT_RESULTS, TNOT_GOT_RESULTS,
  TVOTING, TVOTED, TNOT_VOTED, TRESET_RESULTS,
  TCREATING_POLL, TCREATED_POLL, TNOT_CREATED_POLL,
  TGETTING_TWTS, TGOT_TWTS, TNOT_GOT_TWTS,
  TDELETING_POLL, TDELETED_POLL, TNOT_DELETED_POLL,
} from '../actions/types';

const QRES_INIT = {query: '', polls: []};

const INIT_STATE = {
  vote_results: '',
  data: {},
  results: {},
  qresults: QRES_INIT,
  searching: false,
  random: '',
  twt_ids: [],
  twt_err: '',
  error: '',
  loading: false,
  creating: false,
  gettingTwts: false,
  loadingResults: false,
  randomPollLoading: false,
  updatedDescr: null,
};

export default function(state=INIT_STATE, action) {
  switch(action.type) {
    case TRESET_PDATA:
      return {...state, ...INIT_STATE}

    case TRESET_POLL_ERROR:
      return {...state, error: ''}

    case TDELETING_POLL:
    case TGETTING_POLL:
    // case TVOTING:
      return {...state, loading: true}

    case TGOT_POLL:
      return {...state, loading: false, data: action.data}

    case TNOT_GOT_POLL:
      return {...state, loading: false, error: action.errMsg, data: {} }

    case TVOTED:
      // console.log('vote_id ->> ', action.vote_id)
      return {...state, vote_results: action.vote_results}

    case TDELETED_POLL:
      alert('Your poll has been archived, and will be automatically deleted.')
      return {...state, loading: false}

    case TNOT_DELETED_POLL:
    case TNOT_VOTED:
      return {...state, loading: false, error: action.errMsg}

    case TSEARCHING_POLLS:
      return {...state, searching: true, qresults: QRES_INIT}

    case TSEARCHED_POLLS:
      const qr = {query: action.data.query, polls: action.data.qresults}
      return {...state, searching: false, qresults: qr}

    case TNOT_SEARCHED_POLLS:
      return {...state, searching: false, error: action.errMsg}

    case TGETTING_RESULTS:
      return {...state, loadingResults: true, results: {} }

    case TGOT_RESULTS:
      return {...state, loadingResults: false, results: action.results}

    case TNOT_GOT_RESULTS:
      return {...state, loadingResults: false, error: action.errMsg }

    case TRESET_RESULTS:
      return {...state, loadingResults: false, results: {} }

    case TGETTING_RAND_POLL:
      return {...state, randomPollLoading: true}

    case TGOT_RAND_POLL:
      return {...state, randomPollLoading: false, random: action.random}

    case TNOT_GOT_RAND_POLL:
      return {...state, randomPollLoading: false, error: action.errMsg}

    case TCREATING_POLL:
     return {...state, creating: true}

    case TCREATED_POLL:
     return {...state, creating: false}

    case TNOT_CREATED_POLL:
     return {...state, creating: false, error: action.errMsg}

    case TGETTING_TWTS:
     return {...state, gettingTwts: true}

    case TGOT_TWTS:
     return {...state, gettingTwts: false, twt_ids: action.twts}

    case TNOT_GOT_TWTS:
     return {...state, gettingTwts: false, twt_ids: action.twts, twt_err: action.errMsg}

    case TEDIT_POLL:
      // eslint-disable-next-line
      return {...state, ['updated']: action.payload.data}

    case TGET_POLL_RES:
      return {...state, 'results': action.payload.data}

    case TGET_POLLS_CREATED:
      // eslint-disable-next-line
      return {...state, ['created_by']: action.payload.data}

    case TGET_POLLS_TAKEN:
      // eslint-disable-next-line
      return {...state, ['taken_by']: action.payload.data}

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_poll.js